import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrDeviceResponseObj } from '@/api/routes/stat/types';

import { fetchAggrDevice } from './actionCreators';

interface InitialState {
  aggrDevices: AggrDeviceResponseObj [],
  prevAggrDevices: AggrDeviceResponseObj [],
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  aggrDevices: [],
  prevAggrDevices: [],
  isLoading: false,
  error: '',
};

export const aggrDevicesSlice = createSlice({
  name: 'aggrDevices',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAggrDevice.fulfilled.type]: (state, action: PayloadAction<AggrDeviceResponseObj []>) => {
      state.isLoading = false;
      state.error = '';
      state.prevAggrDevices = state.aggrDevices;
      state.aggrDevices = action.payload;
    },
    [fetchAggrDevice.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchAggrDevice.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default aggrDevicesSlice.reducer;
